<app-kyc-accordion accordionKey="bankDetails" accordionTitle="Bank Details">

  <!-- Bank Forms -->
  <div *ngFor="let bankForm of bankForms; let i = index" class="mb-8 border p-4 rounded-md">
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-semibold">Bank Account {{i + 1}}</h3>
      <button 
        *ngIf="bankForms.length > 1" 
        type="button" 
        (click)="removeBankForm(i)" 
        class="text-red-600 hover:text-red-800">
        Remove
      </button>
    </div>

    <fieldset>
      <legend class="text-sm font-semibold leading-6 text-gray-900">
        Account Type
      </legend>
      <p class="mt-1 text-sm leading-6 text-gray-600">
        Select the type of account you want to create/update.
      </p>

      <div class="mt-6 space-y-6 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
        <div class="flex items-center">
          <input
            id="local-{{i}}"
            name="bank-account-type-{{i}}"
            type="radio"
            (change)="toggleBankRegion($event, 'local', i)"
            [checked]="bankForm.get('region')?.value === 'local'"
            class="h-4 w-4 border-gray-300 text-mango focus:ring-mango"
          />
          <label
            for="local-{{i}}"
            class="ml-3 block text-sm font-medium leading-6 text-gray-900"
            >Local Account</label
          >
        </div>
        <div class="flex items-center">
          <input
            id="foreign-{{i}}"
            name="bank-account-type-{{i}}"
            type="radio"
            (change)="toggleBankRegion($event, 'foreign', i)"
            [checked]="bankForm.get('region')?.value === 'foreign'"
            class="h-4 w-4 border-gray-300 text-mango focus:ring-mango"
          />
          <label
            for="foreign-{{i}}"
            class="ml-3 block text-sm font-medium leading-6 text-gray-900"
            >Foreign Account</label
          >
        </div>
      </div>
    </fieldset>

    <hr class="my-6" />

    <form [formGroup]="bankForm">
      <div class="form-row flex flex-col gap-5 md:grid md:grid-cols-3 md:gap-x-5">
        <!-- Currency -->
        <div>
          <app-input-label labelClass="label--bottom-margin">Currency</app-input-label>
          <select
            name="bank-branch"
            required
            base-select
            formControlName="currency"
          >
            <option value="" disabled selected>Currency</option>
            <option
              *ngFor="let currency of currencyList"
              [value]="currency.value"
            >
              {{ currency.label }}
            </option>
          </select>
        </div>
        
        <!-- Bank Name - Foreign -->
        <div [ngClass]="{ hidden: bankForm.get('region')?.value === 'local' }">
          <app-input-label labelClass="label--bottom-margin">Bank Name - Foreign</app-input-label>
          <app-input
            placeholder="Enter Foreign Bank Name"
            inputClass="input--padding"
            formControlName="bank_name"
          ></app-input>
        </div>

        <!-- Bank Name - Local -->
        <div [ngClass]="{ hidden: bankForm.get('region')?.value === 'foreign' }">
          <app-input-label labelClass="label--bottom-margin">Bank Name - Local</app-input-label>
          <select
            name="bank-name"
            required
            base-select
            formControlName="bank_code"
            #bankName
          >
            <option value="" disabled selected>
              {{
                (isBankListLoading$ | async) === true
                  ? '...Fetching the list of banks'
                  : banks.length === 0
                    ? 'No banks available'
                    : 'Select Bank'
              }}
            </option>
            <option *ngFor="let bank of banks" [value]="bank.bankCode">{{ bank.bankName }}</option>
          </select>
        </div>

        <!-- Account number -->
        <div>
          <app-input-label labelClass="label--bottom-margin">Account number</app-input-label>
          <app-input
            placeholder="Enter Account number"
            inputClass="input--padding"
            formControlName="bank_account_number"
            (ngModelChange)="validateBankAccountNo(bankForm)"
            [isDisabled]="
              (!bankForm.get('bank_code')?.value && bankForm.get('region')?.value === 'local') ||
              (isBankValidationLoading$ | async) === true
            "
          ></app-input>
        </div>

        <!-- Account name -->
        <div>
          <app-input-label labelClass="label--bottom-margin">Account name</app-input-label>
          <app-input
            [placeholder]="
              (isBankValidationLoading$ | async)
                ? '...Fetching Account Name'
                : 'Enter Account Number'
            "
            inputClass="input--padding"
            formControlName="bank_account_name"
            [isDisabled]="bankForm.get('region')?.value === 'local'"
          ></app-input>
        </div>

        <!-- Bank Branch -->
        <div>
          <app-input-label labelClass="label--bottom-margin">Bank Branch</app-input-label>
          <app-input
            placeholder="Enter Bank Branch"
            inputClass="input--padding"
            formControlName="bank_branch"
          ></app-input>
        </div>

        <!-- Bank Sort Code -->
        <div>
          <app-input-label labelClass="label--bottom-margin">Bank Sort Code</app-input-label>
          <app-input
            placeholder="Enter Bank Sort Code"
            inputClass="input--padding"
            formControlName="bank_sort_code"
          ></app-input>
        </div>
      </div>
    </form>
  </div>

  <div class="mt-5 flex justify-between items-center">
    <!-- Add bank details button -->
    <button type="button" mango-button (click)="addBankForm()" class="w-fit">
      + Add Another Bank Account
    </button>

  <!-- Submit Button -->
    <div [ngClass]="{'cursor-not-allowed': (isUpdating$ | async) || (isAddingNewBankInfo$ | async)}">
      <button
        type="button"
        mango-button
        [loading]="(isUpdating$ | async) || (isAddingNewBankInfo$ | async)!"
        [disabled]="(isUpdating$ | async) || (isAddingNewBankInfo$ | async)!"
        (click)="submitAllBankDetails()"
        class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end"
      >
        <span
          *ngIf="(isUpdating$ | async) || (isAddingNewBankInfo$ | async)"
          spin
          [loadingText]="(isBankCreated$ | async) ? 'Updating Bank Info...' : 'Saving Bank Info...'"
        ></span>
        <ng-container *ngIf="!(isUpdating$ | async) && !(isAddingNewBankInfo$ | async)">
          {{ (isBankCreated$ | async) ? 'Update Bank Details' : 'Save Bank Details' }}
        </ng-container>
      </button>
    </div>
  </div>
</app-kyc-accordion>